import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const DEV_IMG =
  "https://images.unsplash.com/photo-1475070929565-c985b496cb9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGx1eHVyeSUyMGludmVzdG9yJTIwbmF0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODU2ODM4MTd8MA&ixlib=rb-4.1.0&q=85";

export const Developer = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="developer" ref={ref} className="relative h-[90vh] min-h-[600px] overflow-hidden flex items-center border-y border-white/10">
      <motion.div style={{ y }} className="absolute inset-0 -top-[12%] -bottom-[12%]">
        <img src={DEV_IMG} alt="Development opportunity in nature" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-oed-base/75" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-xs uppercase tracking-[0.3em] text-oed-gold mb-6"
        >
          Become The Developer Too
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-black uppercase tracking-tighter leading-[0.9] text-6xl md:text-8xl lg:text-[9rem]"
        >
          Earn <span className="text-oed-gold">40%</span>
          <br />Revenue Stream
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-8 max-w-xl text-base md:text-lg text-white/70 leading-relaxed"
        >
          When investors and landowners want to build tiny-home villages, glamping resorts, eco
          retreats or sustainable communities, OED Glampire Network contractors work with you to
          bring the project to life — while you earn on qualifying development projects.
        </motion.p>
      </div>
    </section>
  );
};
